export interface LatLng {
  lat: number
  lng: number
}

export enum NBRequestStatus {
  OK = 'Ok',
  InvalidParams = '400',
  InvalidAPIKey = '401',
  InsufficientPermission = '403',
  RouteGenerateFailed = '422',
  RequestLimited = '429',
}

export interface StepIntersections {
  bearings: number[]
  classes: string[]
  entry: boolean[]
  intersection_in: number
  intersection_out: number
  lanes: {
    indications: string[]
    valid: boolean
  }[]
  location: {
    latitude: number
    longtiude: number
    name?: string
  }
}

/**
 * @interface StepManeuver
 * The manuver information in the step.
 */
export interface StepManeuver {
  bearing_before: number
  bearing_after: number
  coordinate: {
    latitude: number
    longitude: number
    name?: string
  }
  instruction?: string
  maneuver_type: string
  modifier?: string
  muted?: boolean
  voice_instruction: {
    distance_along_geometry: number
    instruction: string
    unit: string
  }[]
}
